import React, {useState, useEffect} from 'react';
import Navbar from '../Navbar';
import { toast } from 'react-toastify';
import { ExportToExceltillRTO } from '../Excelfile';
import { ExportToExcelcmRTO } from '../Excelfile';

const MonthendReport = () => {

    const [datefromValue, setDatefromValue] = useState(null);
    const [datetoValue, setDatetoValue] = useState(null);
    const [divvalue, setDivvalue] = useState(''); 
    const [values, setValues] = useState([]);
    const [selectinvsitedata, setSelectinvsitedata] = useState();
    const [hqNamedata, setHqNamedata] = useState('');  
    const [rtodivwisedata, setRtodivwisedata] = useState([{}]);
    const [btnreport, setBtnreport] = useState('none');
    const [btngreport, setBtngreport] = useState('');
    const [rtodivcmwisedata, setRtodivcmwisedata] = useState([{}]);
    const [btncmreport, setBtncmreport] = useState('none');
    const [btngcmreport, setBtngcmreport] = useState('');

    const tcsfromDate = datefromValue;
    const tcstoDate = datetoValue;


    const divisionlist = async () => {
        try {
            // let hqhirdata = userData.hqCode;
            // console.log(hqhirdata);
            const hqres = await fetch('/mnthenddb/divisionlist', {
                method: "GET",
                    headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json"
                    },
                    credentials: "include"  
            });
            
            const hqresdata = await hqres.json();
            if(hqresdata.status === 404)
            {
                toast.error("You don't have access of HQ.", { position: "top-center" });
            }
            else
            {
            // console.log(hqresdata);
            setValues(hqresdata);
            }
        
          
        } catch (error) {
          console.log(error);
        }
      }

    const handlefromDateUpdate = async(e) => {        
        const datefValue = e.target.value; 

        // console.log("from:", datefValue);
        setDatefromValue(datefValue);       
        // console.log("from:", datefValue);        
      }

      const handletoDateUpdate = async(e) => {        
        const datetValue = e.target.value;        
        // console.log("to:", datetValue);        
        setDatetoValue(datetValue);       
        // console.log("to:", datetValue);
      }

      const handledivlistdata = async(e) => {
        setDivvalue(e.target.value);
        const hqfvaluedata = e.target.value;
        if(hqfvaluedata === "--Select--")
          {
              toast.error("Please Select the Division.", { position: "top-center" });
          } 
        //   else{
        // const hqnamefvalue = values.filter((fdata) => (fdata.hqCode === hqfvaluedata))
        // setSelectinvsitedata(hqfvaluedata);
        // setHqNamedata(hqnamefvalue[0].hqName);
        // console.log(hqnamefvalue[0].hqName);
        //   }
      }


      const rtocmdivwisereport = async () => {
        try {
            
            let divisionname = divvalue;
            // let yearmonth = datefromValue;
            
            if(!divisionname)
            {
                toast.error("Please Select the Data.", { position: "top-center" });
            }
            else
            {
            setBtngcmreport('none');
            setBtncmreport('none');
            // console.log(hqhirdata);
            const rtores = await fetch('/mnthenddb/divwisecmrtoreport/'+divisionname, {
                method: "GET",
                    headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json"
                    },
                    credentials: "include"  
            });
            
            const rtoresdata = await rtores.json();
            // console.log(hqresdata);
            if(rtores.status === 404)
            {
                toast.error("There is not data for Display.", { position: "top-center" });
                setBtncmreport('');
                setBtngcmreport('')
            }
            else
            {
            console.log(rtoresdata);
            setRtodivcmwisedata(rtoresdata);
            setBtncmreport('');
            setBtngcmreport('');
            }
            }
            
          
        } catch (error) {
            console.log(error);
            setBtncmreport('');
            setBtngcmreport('');
        }
      }

      const rtodivwisereport = async () => {
        try {            
            let divisionname = divvalue;
            let yearmonth = datefromValue;
            
            if(!divisionname || !yearmonth)
            {
                toast.error("Please Select the Data.", { position: "top-center" });
            }
            else
            {
                setBtngreport('none');
                setBtnreport('none');
            const rtores = await fetch('/mnthenddb/divwisertoreport/'+divisionname + '/' + yearmonth, {
                method: "GET",
                    headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json"
                    },
                    credentials: "include"  
            });
            
            const rtoresdata = await rtores.json();
            // console.log(hqresdata);
            if(rtores.status === 404)
            {
                toast.error("There is not data for Display.", { position: "top-center" });
                setBtnreport('');
                setBtngreport('');
            }
            else
            {
            // console.log(hqresdata);
            setRtodivwisedata(rtoresdata);
            setBtnreport('');
            setBtngreport('');
            }
            }
            
          
        } catch (error) {
            console.log(error);
            setBtnreport('');
            setBtngreport('');
        }
      }

      useEffect (() => {
        // pagauth();
        // loginAuthorized();
        divisionlist();
        
        
      }, []);

  return (
    <>
    <div className="">
    <Navbar />   
    </div>
    <div className='d-flex justify-content-center align-items-top bg-white vh-100'>
    <div className='mt-3 w-100'>
    <div className='bg-white p-3 rounded w-100'>
    <div className='bg-info w-25 rounded-1 mt-1'>Standard MIS Reports:</div>
    <div className='d-flex mt-2 flex-column align-items-center'>
    <div className='mb-2'>
    <label style={{textAlign:"right", width:"100px"}}>Division:-</label>    
    <select className='ms-0 rounded-1' style={{width:"150px"}} onChange={handledivlistdata} >
                        <option defaultValue={true}>--Select--</option>
                        {
                          values.map((opt,i)=><option key={i}>{opt.DivisionName}</option>)
                        }   
                        </select>
    <label style={{textAlign:"right", width:"100px"}}>YearMonth:-</label>    
    <input type="text" id="yearmonth" onChange={(e) => handlefromDateUpdate(e)} />
    {/* <label style={{textAlign:"right", width:"100px"}}>To Date:-</label>    
    <input style={{marginRight:"50px"}} type="text" id="todate" onChange={(e) => handletoDateUpdate(e)} />     */}
    <button className='btn btn-primary rounded-1 ms-1'disabled={btngcmreport} onClick={rtocmdivwisereport}>1. Current RTO </button>
    <span className='fs-6 ms-2' style={{display:btncmreport}}><ExportToExcelcmRTO reportcmrto={rtodivcmwisedata} /></span>
    <button className='btn btn-primary rounded-1 ms-1'disabled={btngreport} onClick={rtodivwisereport}>2. Previous RTO </button>
    <span className='fs-6 ms-2' style={{display:btnreport}}><ExportToExceltillRTO reporttillrto={rtodivwisedata} /></span>
    
    </div>        
    </div>
    </div>
    </div>
    </div>
    </>
  )
}

export default MonthendReport
